'use client';

import { asText, Content, isFilled } from '@prismicio/client';

import {
  appendSearchParams,
  useRetainableSearchParamsContext,
} from '@preventx/prismic-services';
import { Breadcrumbs, BreadcrumbOption } from '@preventx/oxygen';

// Services
import { applicationEnv } from '@/services/env/shared';

type HeadlineBreadcrumbsProps = {
  breadcrumbs:
    | Content.ClinicHeadlineSliceDefaultPrimaryBreadcrumbsItem[]
    | Content.PageHeroHeadlineSliceWithBackgroundGraphicPrimaryBreadcrumbsItem[]
    | Content.ClinicHeadlineSliceWithClinicFinderHeadlinePrimaryBreadcrumbsItem[];
};

export const HeadlineBreadcrumbs = ({
  breadcrumbs,
}: HeadlineBreadcrumbsProps) => {
  const { searchParams } = useRetainableSearchParamsContext();

  const { WebsiteUrl } = applicationEnv();

  return (
    <Breadcrumbs
      label="Breadcrumbs"
      options={breadcrumbs.map((breadcrumb, index): BreadcrumbOption => {
        const { link } = breadcrumb;

        let path: string | undefined = undefined;

        if (isFilled.link(link)) {
          path = appendSearchParams({
            link: link,
            as: 'default',
            searchParams: searchParams,
            applicationUrl: WebsiteUrl,
          });
        }

        const label = asText(breadcrumb.label);

        return {
          text: label,
          href: path ?? '',
          type: path ? 'link' : 'no-link',
          id: `navigational-breadcrumbs-${index + 1}`,
        } satisfies BreadcrumbOption;
      })}
    />
  );
};
